import React, {Component, PropTypes} from 'react'
import Cannonicalize from '../Cannonicalize'
import Carousel from '../Carousel'
import Tile from '../Tile'
import Analytics from '../Analytics'
const LeftControl = (props)=> <span className="fa fa-chevron-left fa-caret-left fa-angle-left" aria-hidden="true"><span className="sr-only">Previous</span></span>
const RightControl = (props) => <span className="fa fa-chevron-right fa-caret-right fa-angle-right" aria-hidden="true"> <span className="sr-only">Next</span></span>


class SkyCam extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.state = {
      stories: []
    }

  }

  componentWillMount() {

    try {
      this.setState( {stories: Cannonicalize.skyCam(this.props.FRN_rawResponses[0].data).map(this.skyCamToStory)})
    } catch (e) {
      e.message += ' in Skycam'
      Analytics.reportError(e)
    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('skyCam').then((res) => {
      this.setState({stories: res.map(this.skyCamToStory)})
    })
  }

  skyCamToStory(skycam){
    return  { headline: skycam.cam_name,
              abstractimage: {
                filename: skycam.file_path + (skycam.type == 'webcam' ? '.jpg?' : '00001.jpg?') + Date.now()
              },
              link: 'skycam-network/'+ skycam.id
            }
  }


  render() { // REQUIRED
    try {
      if (this.state.length < 1)
        return null
    return (
      <div className='gnm-sky-cam '>
        <h5 className='white-at-small'>{this.props.title}</h5>
        <Carousel leftControl ={<LeftControl />} rightControl={<RightControl />} paddingTop='49px'>
          <div className='row '>
          {this.state.stories.slice(0,6).map(function(s,i,a){
            return (
                <div  key={i}>
                  <div className="col-sm-4 " >
                    <Tile story={s} gradient={true}></Tile>
                  </div>
                </div>
            )
          })}
          </div>
          <div className='row '>
          {this.state.stories.slice(6,12).map(function(s,i,a){
            return (
              <div  key={i}>
                <div className="col-sm-4  "  key={i}>
                  <Tile story={s} gradient={true}></Tile>
                </div>
              </div>
            )
          })}
          </div>
          <div className='row '>
          {this.state.stories.slice(12,18).map(function(s,i,a){
            return (
              <div  key={i}>
                <div className="col-sm-4 "  key={i}>
                  <Tile story={s} gradient={true}></Tile>
                </div>
              </div>
            )
          })}
          </div>
          <div className='row '>
          {this.state.stories.slice(18,24).map(function(s,i,a){
            return (
              <div  key={i}>
                <div className="col-sm-4 "  key={i}>
                  <Tile story={s} gradient={true}></Tile>
                </div>
              </div>
            )
          })}
          </div>
        </Carousel>

      </div>
    )
    }catch(e){
      e.message += ' in SkyCam, causing render failure';
      Analytics.reportError(e)
      return null
    }
  }
}

export default SkyCam



// WEBPACK FOOTER //
// ./app/components/custom/ssr/SkyCam/index.js